export const BOOKING_DATE_YEARS_BACK = 2;
export const BOOKING_DATE_YEARS_FORWARD = 4;
export const BOOKING_DATE_RANGE_YEARS = 2;
